import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { TranslateModule } from '@ngx-translate/core';
import { SecurityModule } from '../../security/security.module';
import { zAppMenuControlComponent } from './MenuControl.component';
import { MenuInternalService } from './MenuControl.service';
import {TieredMenuModule} from 'primeng/tieredmenu';
import { zAppDevIconismModule } from '@framework/components/Iconism/iconism.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {RippleModule} from "primeng/ripple";
import {zAppDevBreadcrumbModule} from "@framework/components/SearchModal/SearchModal.module";
import {zAppDevButtonModule} from "@framework/components/Button/button.module";

const MenuComponents = [ zAppMenuControlComponent ];
const MENU_PROVIDERS = [ MenuInternalService ];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SecurityModule,
    MenubarModule,
    TieredMenuModule,
    zAppDevIconismModule,
    AutoCompleteModule,
    RippleModule,
    zAppDevBreadcrumbModule,
    zAppDevButtonModule
  ],
  declarations: [...MenuComponents],
  exports: [...MenuComponents],
})
export class zAppDevMenuControlModule {
  static forRoot(): ModuleWithProviders<zAppDevMenuControlModule> {
    return {
      ngModule: zAppDevMenuControlModule,
      providers: [
        ...MENU_PROVIDERS
      ],
    };
  }
}
